export var trunTo = function (value) {
    var num = Number(value);
    if (!Number.isNaN(num)) {
        return num > 99 ? '99+' : num;
    }
    return value;
};
//# sourceMappingURL=math.js.map